import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

const formatDate = (date: string | dayjs.Dayjs | Date, format: string, inputFormat?: string) => {
  if (!date) return "";

  // For full date strings like "Sat Oct 23 1920 00:00:00 GMT+0100"
  if (typeof date === "string" && date.includes("GMT")) {
    // Parse using native Date first to handle timezone correctly
    const parsedDate = new Date(date);
    return dayjs(parsedDate).format(format);
  }

  // For other cases, use the existing logic
  if (inputFormat) {
    return dayjs(date, inputFormat).format(format);
  }

  return dayjs(date).format(format);
};

export default formatDate;